var render = function render(_c,_vm){return _c('container',{staticClass:"parzival-fullheight",attrs:{"manuscript":_vm.props.manuscript,"pages":_vm.props.pages,"verse":_vm.props.verse}},[_c('facsimile-viewer',{attrs:{"manuscript":_vm.props.manuscript,"pages":_vm.props.pages,"numbered":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }